import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Routes, Route, Navigate } from "react-router-dom";
import { layoutTypes } from "./constants/layout";

// Import Routes
import { authProtectedRoutes, publicRoutes } from "./routes";

// Import Middleware and Layouts
import Authmiddleware from "./routes/route";
import VerticalLayout from "./components/VerticalLayout/";
import HorizontalLayout from "./components/HorizontalLayout/";
import NonAuthLayout from "./components/NonAuthLayout";

// Import SCSS
import "./assets/scss/theme.scss";
// Import Customer Theme (Purple Gradient for Sidebar & Section Headings)
import "./assets/css/customer-theme.css";
// Import Theme Switcher
import { initTheme } from "./utils/themeSwitcher";
// Import Number Input Scroll Disabler
import { initDisableNumberInputScroll } from "./utils/disableNumberInputScroll";

// Function to get the layout
const getLayout = (layoutType) => {
  let Layout = VerticalLayout;
  switch (layoutType) {
    case layoutTypes.VERTICAL:
      Layout = VerticalLayout;
      break;
    case layoutTypes.HORIZONTAL:
      Layout = HorizontalLayout;
      break;
    default:
      break;
  }
  return Layout;
};

const App = () => {
  const layoutType = useSelector((state) => state.Layout.layoutType);
  const Layout = getLayout(layoutType);

  // Initialize theme on app load
  useEffect(() => {
    initTheme();
    // Initialize global scroll prevention for number inputs
    initDisableNumberInputScroll();
  }, []);

  return (
    <React.Fragment>
      <Routes>
        {/* Public Routes */}
        {publicRoutes.map((route, idx) => (
          <Route
            path={route.path}
            key={idx}
            element={route.element} // Use `element` instead of `component`
          />
        ))}

        {/* Auth Protected Routes */}
        {authProtectedRoutes.map((route, idx) => (
          <Route
            path={route.path}
            key={idx}
            element={
              <Authmiddleware>
                <Layout>{route.element}</Layout> {/* Use `element` instead of `component` */}
              </Authmiddleware>
            }
          />
        ))}

        {/* Fallback Route for No Matches */}
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </React.Fragment>
  );
};

App.propTypes = {
  layout: PropTypes.any,
};

export default App;
